<div class="status__content">
	{{cellValue?.smartQCStateDescription || ''}}
</div>
